import { HomeworkSystemMessageEnum } from 'store/models/chunks/homework/types';

export const systemMessageText: Record<HomeworkSystemMessageEnum, string> = {
  [HomeworkSystemMessageEnum.checking]: 'На проверке',
  [HomeworkSystemMessageEnum.rejected]: 'Возвращено на доработку',
  [HomeworkSystemMessageEnum.finished]: 'Принято',
};
